import React from 'react';

const size = 30;
const style = {
  position: 'absolute',
  top: 0,
  right: 0,
  fontStyle: 'normal',
  textAlign: 'center',
  height: `${size}px`,
  width: `${size}px`,
  lineHeight: `${size}px`,
  borderRadius: `${size / 2}px`,
  border: `1px solid #ddd`,
  background: '#eee',
};

export default function RenderCount() {
  const renders = React.useRef(0);

  return <i style={style}>{++renders.current}</i>;
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/RenderCount.jsx